import React, { useState } from 'react'
import "./ProductInfo.css"
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner, Toast, ToastContainer } from 'react-bootstrap';
import { fetchCart } from '../../hook/cart';
import { toast } from 'react-toastify';
import AlertContainer from '../Alert/Alert';

function ProductInfo({ info }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const priceAfterPrec = info?.discounted_price_egp * 100
  const prec = 100 - (priceAfterPrec / info?.price_egp)

  const navigate = useNavigate()
  const [count, setCount] = useState(1);
  const userinfo = useSelector((state) => state);
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState('');
  const [severity, setSeverity] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()

const fullUrl = window.location.href;

  // النص اللي جاي من الـ API
  const apiText = info?.description


  // دالة لتقسيم النص لعناوين
  function parseDescription(text) {
    const sections = {};


    return sections;
  }

  // جرب
  const parsed = parseDescription(apiText);

  console.log(parsed);



  const addToCart = async (e) => {
    e.preventDefault();
    if (userinfo?.auth?.access_token !== undefined) {


      setShow(false)
      setLoading(true)

      await axios
        .post(`https://nanosoft.technology/smile/api/cart`, {

          "product_id": info.id,
          "quantity": count

        }, {
          headers: {
            Authorization: `Bearer ${userinfo?.auth?.access_token}`
          }
        })
        .then(async (res) => {
          setLoading(false)
          dispatch(fetchCart());
          setShow(true)
          setMsg(currentLocal.home.addsuccessMessage)
          setSeverity("success")

          setTimeout(() => {
            setShow(false)

          }, 2000);
        })
        .catch((error) => {

          console.log(error.response.data);


        });


    } else {
      navigate('/login')
    }

  }
  const makeCall = () => {
        const url = `https://wa.me/+201033331251?text=${encodeURIComponent(fullUrl)}`;
    window.open(url, "_blank");

  };

  return (
    <div className='ProductInfo_container py-5'>
      {show &&
        <AlertContainer
          msg={msg}
          severity={severity}
        />

      }

      <div className='border-bottom pb-3'>
        <p className='mb-0'>{info && info?.category}</p>
        <h3 className='mb-3'>{currentLocal.language === "English" ? info && info?.name_en : info && info?.name_ar}</h3>
        {info && info?.discounted_price_egp ?
          <>
            <p className='mb-0 price text-decoration-line-through'>LE {Number(info && info?.price_egp).toFixed(2)}</p>
            <p className='mb-0 price'>LE {Number(info && info.discounted_price_egp).toFixed(2)}</p>
          </>
          :
          <p className='mb-0 price_discount'>LE {Number(info && info.price_egp).toFixed(2)} </p>

        }
        {info && info.price_egp != 0 &&
          <div className=' d-flex'>
            <p
              className='bg-danger text-white rounded py-1 px-2'
            >{prec.toFixed(2)}%</p>
          </div>
        }
      </div>

      <div style={{ marginBottom: "20px", marginTop: "20px", }}>
        <h5>{currentLocal.home.describtion}</h5>
        <p>{currentLocal.language == "English" ? info?.description_en : info?.description_ar}</p>
      </div>
      <div >
        <div className='Quantity border-bottom pb-3'>



          <div>
            <div className='mini_cart_actions'>
              <div className='quantity pr mr__10 qty__true'>
        


          
            

        <button type="button" className="plus db cb pa pd__0 pr__15 tr r__0" onClick={() => setCount(count + 1)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                    </svg>
                  </button>
                <input type="number" id="miniupdates_45938813829338:0bcb7a5c7ef74768b1e41bbdadc60948" data-id="45938813829338:0bcb7a5c7ef74768b1e41bbdadc60948" className="input-text qty text tc qty_cart_js" step="1" min="0" max="5" name="updates[]" value={count} size="4" pattern="[0-9]*" inputMode="numeric" />
                <div className="qty tc fs__14">
                  <button type="button" className="minus db cb pa pd__0 pl__15 tl l__0 qty_1" onClick={() => { if (count > 0) { setCount(count - 1) } }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-dash" viewBox="0 0 16 16">
                      <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
                    </svg>
                  </button>

                </div>
              </div>
            </div>
            <p className=' mb-4 fw-bold'>
              {currentLocal.home.orderProduct} <button className="text-decoration-underline fs-5"onClick={makeCall}><span>+201033331251</span></button>
            </p>
            <button className='add_to_card d-flex justify-content-center align-items-center' onClick={(e) => {
              if (userinfo?.auth?.access_token) {
                addToCart(e);
              } else {
                navigate("/login")
              }
            }} disabled={loading && true}>

              {loading &&
                <Spinner animation="border" role="status" className='mx-3' size="sm">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              }
              <p className='mb-0'>
                {currentLocal.home.addtocart}
              </p>
            </button>

          </div>

        </div>
        <div>
          {/* <div className='w-100'>
                        <img src={info && info.dimensionsImages[0]} alt='' className='my-3 w-100' />

                    </div> */}
          {/* <p className='my-3 fs-6 fw-bold text-end w-100'>سياسة الاستبدال و الاسترجاع</p> */}

          <div className='mt-4'>

            <div style={{ marginBottom: "20px" }}>
              <h5>{currentLocal.home.howtouse}</h5>
              <p>{currentLocal.language == "English" ? info?.how_to_use_en : info?.how_to_use_ar}</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h5>{currentLocal.home.Benefitsofuse}</h5>
              <p>{currentLocal.language == "English" ? info?.benefits_en : info?.benefits_ar}</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h5>{currentLocal.home.activeIngredients}</h5>
              <p>{currentLocal.language == "English" ? info?.active_ingredients_en : info?.active_ingredients_ar}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductInfo